// extracted by mini-css-extract-plugin
module.exports = {"search":"Search_search__1YRqH","divSearch":"Search_divSearch__1exqS"};